import React, { useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { environmentSelector } from '../../selectors/commonSelectors';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { FormattedMessage } from 'react-intl/dist';
import DatePicker from 'react-datepicker';
import {
    itemStatus,
    allowedRoles
} from './IssuerConstants';
import { Button, Modal, AccordionPanel } from 'app-components';

import { formatDate, getDateObject, parseDate, parseDateWithFormat } from '../../utils/dates/date.utils';
import GIButton from '../../components/common/button/GIButton';

import useIssuerEdiTesting from './useIssuerEdiTesting';

function IssuerEdiTestingDetailsContainer(props) {
    const {
        user
    } = useSelector(environmentSelector);

    const [showSetting, setShowSetting] = useState(false);
    const [allowed, setAllowed] = useState(false);

    const [showModal, setShow] = useState(false);
    const { executeStep, getTestResults, restartTestCase, testResults, apiError } = useIssuerEdiTesting();
    const history = useHistory();

    const handleShow = () => setShow(true);
    const handleClose = e => {
        e.preventDefault();
        setShow(false);
    };

    let activeScenario = props.location.state.response.activeScenario;
    if (!activeScenario) {
        activeScenario = 0;
    }
    let activeStep = parseInt(props.location.state.response.activeStep);
    if (!activeStep) {
        activeStep = 1;
    }
    const restartTest = async () => {
        const sResponse = props.location.state.response;
        const restartObj = {
            "hiosIssuerId": sResponse.hiosIssuerId,
            "insuranceType": sResponse.insuranceType,
            "testCaseId":sResponse.testCaseId,
            "scenarioId": sResponse.activeScenario+'',
            "stepId": activeStep,
            "restartTestCase": true,
            "restartStep": false
        }
        return await restartTestCase(restartObj);
    };

    const restartStep = async (stepId) => {
        const sResponse = props.location.state.response;
        const restartObj = {
            "hiosIssuerId": sResponse.hiosIssuerId,
            "insuranceType": sResponse.insuranceType,
            "testCaseId":sResponse.testCaseId,
            "scenarioId": sResponse.activeScenario+'',
            "stepId": stepId,
            "restartTestCase": false,
            "restartStep": true
        }
        return await restartTestCase(restartObj);
    };

    
    useEffect(() => {
        if (allowedRoles.includes(user.role)) {
            setAllowed(true);
        }
    }, [user?.role]);
    
    useEffect(() => {
        activeScenario = props.location.state.response.activeScenario;
        if (!activeScenario) {
            activeScenario = 0;
        }
        activeStep = parseInt(props.location.state.response.activeStep);
        if (!activeStep) {
            activeStep = 1;
        }
        // if testResults is empty try to fetch again, should there be a delay here?
        if (testResults && Object.keys(testResults).length === 0) {
            getTestResults(props.location.state.response.hiosIssuerId, props.location.state.response.insuranceType);
            sessionStorage.setItem('issuerEdiStepStated', "false");
        }
    }, [testResults]);

    const goBack = () => {
        history.goBack();
    };
    const settingClick = () => {
        setShowSetting(!showSetting);
    }
    const hideSettingPage = () => {
        if (showSetting) {
            setShowSetting(false)
        }
    }

    const sendStep = async(details) => {
        return await executeStep(details);
    }

    const RestartModal = () => {
        const [stepStartedM, setStepStartedM] = useState(false);
        const [stepError, setStepError] = useState(false);

        const restartTestModal = async () => {
            const res = await restartTest();
            if (res.response?.status === 404) {
                setStepError(res.message)
            } else {
                setStepStartedM(true);
            }
        }

        if (showModal) {
            return (
                <Modal id="restart_tests_modal" >
                    <Modal.Header id="restart_tests_modal_title" titleId='Are you sure?' onHide={() => handleClose} />
                    <Modal.Body>
                        <div>Are you sure you want to restart the test case?</div>
                        <div style={{marginTop: '10px'}}>
                            <span className='font-weight-bold'>Note:</span> This will delete all contents from this test case and start over again from Scenario 1
                        </div>
                        <div className='restart-modal-footer'>
                            <GIButton id='close_modal' variant='secondary' labelId='Cancel' onClickHandler={handleClose}/>
                            <GIButton id='restart_test' isDisabled={!allowed} labelId='Restart test case' onClickHandler={restartTestModal} />
                        </div>
                        <div>
                            {stepStartedM && 
                                <div className='details-middle'>
                                    <div className='step-started'><span className='font-weight-bold'>Restart started.</span> Please refresh in a few minutes to see updates.</div>
                                </div>
                            }
                            {stepError && 
                                <div className='details-middle danger-dark'>
                                    <div className='modal-error'><span className='font-weight-bold'>Restart test failed. </span>{stepError}</div>
                                </div>
                            }
                        </div>
                    </Modal.Body>
                </Modal>
            )
        }
        return null;
    }

    const LeftPanel = () => {
        const evaluateIcon = (index, array) => {
            if (activeScenario === index) {
                return  <FontAwesomeIcon icon="circle" size="xs" className='active-circle ' />
            } else if (index > activeScenario) {
                return <div className="incomplete-details" />
            } else {
                // index < activeScenario
                return <FontAwesomeIcon icon="circle" size="xs" className='done-circle' />
            }            
        };

        // remove \\n from json
        const description = props.location.state.description.description.replace(/\\\\n\s/g,'\n\n');

        return (
            <>
                <div className='left-panel-top pointer' onClick={goBack}>
                    <div className="mr-10px">
                        <FontAwesomeIcon icon="chevron-left" size="1x" className="icon-link" />
                    </div>
                    <div>
                        &nbsp;Back to all tests
                    </div>
                </div>
                <div className='left-panel-bottom'>
                    <div className='left-panel-bottom-top'>
                        <div className='p-tb-3 '>
                            <span className='font-weight-bold'>{props.location.state.description.testCaseName}</span>
                            {allowed && 
                                <span className="icon-right test-container" onClick={settingClick}>
                                    <FontAwesomeIcon icon="ellipsis-v" size="1x" className="icon-link" />
                                    {showSetting ? <div className='restart-test' onClick={handleShow}>Restart Test Case</div> : ''}
                                </span>
                            }
                        </div>
                        <div className=''>{props.location.state.description.testCaseTitle}</div>
                        <div className='p-tb-3 scenarios-title'>Scenarios</div>
                    </div>
                    <div className='left-panel-bottom-middle'>
                        {props.location.state.description.scenarios.map((scenario, index, array) => (
                            <div 
                                className= {activeScenario === index ? 'p-tb-3 f active-scenario' : 'p-tb-3 f scenario'}
                                key={`scenario${index}`} >
                                <div className='f f-space-between w-12 p-r-2'>
                                    <div className="step-wrapper">
                                        {evaluateIcon(index, array)}
                                       {(index+1 !== array.length) ? <div className="vertical-line-details" /> : ''}
                                    </div>
                                    <div className='scenario-number'>{index+1}</div>
                                </div>
                                <div>{scenario.scenarioTitle}</div>
                            </div>
                        ))}
                    </div>
                    <div className='left-panel-bottom-bottom'>
                        <div className='p-t-3 description-title'>Description</div>
                        <div className='p-tb-3 description-text'>
                            {description}
                        </div>
                    </div>
                </div>
            </>
        )
    };

    const checkError = (details) => {
        if (details.errorCode834 && details.errorCode834.length > 0 || details.errorCode999 && details.errorCode999.length > 0 || details.ta1ErrorCode && details.ta1ErrorCode.length > 0) {
            if (details.errorCode999.length > 0) {
                return {errorCode: '999', errorMessage: details.errorMessage999};
            } else if (details.errorCode834.length > 0) {
                return {errorCode: '834', errorMessage: details.errorMessage834};
            } else {
                return {errorCode: 'ta1', errorMessage: details.ta1ErrorMessage};
            }
        }
        return {errorCode: null, errorMessage: null};
    }

    const PanelHeader = ({details}) => {
        return <div className='max-width95'>
            <span className="font-weight-bold">Step {parseInt(details.stepId)}:</span> {details.stepTitle}
        </div>
    }

    const PanelErrorMessage = ({errorDetails, stepObj}) => {
        const [stepStartedE, setStepStartedE] = useState(false);
        const [stepError, setStepError] = useState(false);

        const errorCode = errorDetails.errorCode;
        const errorMessage = errorDetails.errorMessage;

        return (
            <div className='details-bottom'>
                <div className="error-message ">
                    <div className="font-weight-bold">Error {errorCode}</div>
                    <div>{errorMessage}</div>
                    <div className="error-bottom">
                        <GIButton id='restart_step' isDisabled={!allowed && stepError} variant='secondary' labelId='Restart Step' onClickHandler={async () => {
                            const res = await restartStep(stepObj.stepId);
                            if (res.response?.status === 404) {
                                setStepError(res.message)
                            } else {
                                setStepStartedE(true);
                            }

                            // after refresh step started prevent other actions
                            // if refresh step fails, other steps will likely fail too
                            // setAllowed(false);
                        }} />
                        {stepStartedE && 
                            <div className='details-middle'>
                                <div className='step-started'><span className='font-weight-bold'>Restart started.</span> Please refresh in a few minutes to see updates.</div>
                            </div>
                        }
                        {stepError && 
                            <div className='details-middle danger-dark'>
                                <div className='step-started'><span className='font-weight-bold'>Restart step failed. </span>{stepError}</div>
                            </div>
                        }
                    </div>
                </div>
            </div>
        )
    }

    const RPanelStartedBody = ({details, scenarioName}) => {
        // create an array with all used files
        const outboundFiles = [...(details.outbound834FileName ? details.outbound834FileName : []), ...(details.inbound834FileName ? details.inbound834FileName : []), ...(details.outbound999FileName ? details.outbound999FileName: []), ...(details.inbound999FileName ? details.inbound999FileName : []), ...(details.ta1OutboundFileName ? details.ta1OutboundFileName : []), ...(details.ta1InboundFileName ? details.ta1InboundFileName : [])];

        const errorDetails = checkError(details);

        // object to send to restart step
        const sResponse = props.location.state.response;
        const stepObj = {
            "hiosIssuerId": sResponse.hiosIssuerId,
            "insuranceType": sResponse.insuranceType,
            "testCaseId": sResponse.testCaseId,
            "testCaseName" : props.location.state.description.testCaseTitle,
            "scenarioId": activeScenario+1+'',
            "scenarioName" : scenarioName,
            "stepId": details.stepId,
            "stepName" : details.stepTitle,
            "serverRequestTimestamp": formatDate(serverTime, 'YYYY-MM-DD h:mm:ss')
        }

        return (
            <div className='details'>
                <div className='details-top'>
                    <DatePicker 
                        showTimeSelect
                        dateFormat="MMMM d, yyyy  |  h:mm aa"
                        disabled
                        selected={getDateObject(parseDateWithFormat(details.startTime, 'YYYY-MM-DD h:mm:ss'))} 
                        onChange={() => {}}
                    />
                    <div className='mt-15px'>
                        <GIButton isDisabled={true} id='begin_step' labelId='Begin Step' />
                    </div>
                </div>
                <div className='details-middle'>
                    <div className=''>Server time used: 10/27/2022: 12:00AM</div>
                    <div>
                        <p className='display-inline-block details-label details-file'>Files: </p>
                        <div className='display-inline-block'>
                            {outboundFiles.map((file, index) => (
                                <p key={index}>{file}</p>
                            ))}
                        </div>
                    </div>
                    <div>
                        <div className='details-label'><FormattedMessage id='edi.test.details.subscriber_name'/> </div>
                        <p className='details-value'>{details.subscriberName}</p>            
                    </div>
                    <div>
                        <div className='details-label'><FormattedMessage id='edi.test.details.hh_id'/> </div>
                        <p className='details-value'>{details.householdCaseID}</p>            
                    </div>
                    <div>
                        <div className='details-label'><FormattedMessage id='edi.test.details.policy_id'/></div>
                        <p className='details-value'>{details.enrollmentID}</p>            
                    </div>
                    <div>
                        <div className='details-label'><FormattedMessage id='edi.test.details.ob_control_no'/></div>
                        <p className='details-value'>{details?.isa13OBControlNumber}</p>            
                    </div>
                </div>
                {errorDetails.errorCode && <PanelErrorMessage errorDetails={errorDetails} stepObj={stepObj} />}
            </div>
        )
    }
    
    const serverTime = parseDate(Date.now());
    const RPanelNotStartedBody = ({step, scenarioName, index}) => {
        const [stepStarted, setStepStarted] = useState(sessionStorage.getItem('issuerEdiStepStated')==='true');
        const [stepError, setStepError] = useState(false);
        
        const [startDate, setStartDate] = useState(parseDateWithFormat(step.defaultDate.concat(' ', step.defaultTime), 'DD/MM/YYYY h:mm A'));
        const serverDate = formatDate(startDate, 'YYYY-MM-DD h:mm:ss');
        const sResponse = props.location.state.response;
        let stepObj = {
            "hiosIssuerId": sResponse.hiosIssuerId,
            "insuranceType": sResponse.insuranceType,
            "testCaseId": sResponse.testCaseId,
            "testCaseName" : props.location.state.description.testCaseTitle,
            "scenarioId": activeScenario+1+'',
            "scenarioName" : scenarioName,
            "stepId": step.stepId,
            "stepName" : step.stepTitle,
            "serverRequestTimestamp": serverDate
        }
        return (
            <div className='details'>
                {/* Only show datepicker for Step 1 */}
                {index === 0 && 
                    <>
                        <p className='label'>Please select the server date and time to be used for this step.</p>
                        <DatePicker 
                            showTimeSelect
                            dateFormat="MMMM d, yyyy  |  h:mm aa"
                            selected={startDate.toDate()}
                            disabled={!(allowed && !stepStarted) || stepError}
                            minDate={new Date()} 
                            onChange={(date:Date) => {
                                setStartDate(parseDate(date));
                                stepObj.serverRequestTimestamp = formatDate(date, 'YYYY-MM-DD h:mm:ss');
                            }}
                        />
                    </>
                }
                <div className='details-top'>
                    <GIButton isDisabled={!(allowed && !stepStarted) || stepError} id='begin_step' labelId='Begin Step' onClickHandler={async () => {
                        const res = await sendStep(stepObj);
                        if (res.response?.status === 404) {
                            setStepError(res.message)
                        } else {
                            sessionStorage.setItem('issuerEdiStepStated', "true");
                            setStepStarted(true);
                        }
                    }}/>
                </div>
                {stepStarted && 
                    <div className='details-middle'>
                        <div className='step-started'><span className='font-weight-bold'>Step started.</span> Please refresh in a few minutes to see updates.</div>
                    </div>
                }
                {stepError && 
                    <div className='details-middle danger-dark'>
                        <div className='step-started'><span className='font-weight-bold'>Begin step failed. </span>{stepError}</div>
                    </div>
                }
            </div> 
        )
    }
    
    const RPanelStep = ({ details, index, scenarioName, started } ) => {
        const show = (activeStep === index+1) ? true : false;
        const isExpandable = (index < activeStep-1) ? true : false;        

        return (
            <div className={show ? 'active-step accordion-container' : 'accordion-container'}>
                <AccordionPanel
                    id={index}
                    isInitialExpanded={show}
                    header={<PanelHeader details={details} />}
                    isExpandable={isExpandable}
                >
                    {started ? 
                        <RPanelStartedBody details={details} scenarioName={scenarioName} /> :
                        <RPanelNotStartedBody step={details} scenarioName={scenarioName} index={index}/> 
                    }
                </AccordionPanel>
            </div>
        )
    };

    const RightPanel = () => {
        let scenarioSteps;
        const notStartedSteps = props.location.state.description.scenarios[activeScenario].steps;

        const [loading, setLoading] = useState('');
        const refreshClick = () => {
            setLoading('loading-container');
            // give loader some time to spin
            setTimeout(() => {
                getTestResults(props.location.state.response.hiosIssuerId, props.location.state.response.insuranceType);
                if (allowedRoles.includes(user.role)) {
                    setAllowed(true);
                }
            }, 2000);
        }

        {/* render from refresh data, merge steps as needed */}
        const descriptionData = props.location.state.description;
        if (testResults && 'testCases' in testResults && testResults.testCases) {
            if ('insuranceType' in testResults && testResults.insuranceType === props.location.state.response.insuranceType) {
                const modifiedTests = testResults.testCases.find(test => parseInt(test.testCaseId) === (parseInt(props.location.state.response.testCaseId)))?.scenarios[activeScenario]?.steps;
                scenarioSteps = notStartedSteps.map((step, index) => {
                    if (modifiedTests && index < modifiedTests.length) {
                        let mStep = modifiedTests[index];
                        mStep.stepTitle = descriptionData.scenarios[activeScenario].steps[index].stepTitle;
                        if (mStep.status === itemStatus.COMPLETED) {
                            return <RPanelStep details={mStep} key={index} scenarioName={descriptionData.scenarios[activeScenario].scenarioTitle} index={index} started={true} />
                        } else if (mStep.status === itemStatus.IN_PROGRESS) {
                            return <RPanelStep details={mStep} key={index} scenarioName={descriptionData.scenarios[activeScenario].scenarioTitle} index={index} started={true} />
                        } else {
                            // not started state
                            return <RPanelStep details={descriptionData.scenarios[activeScenario].steps[index]} scenarioName={descriptionData.scenarios[activeScenario].scenarioTitle} key={index} index={index} started={false} />
                        }
                    } else {
                        return <RPanelStep details={descriptionData.scenarios[activeScenario].steps[index]} scenarioName={descriptionData.scenarios[activeScenario].scenarioTitle} key={index} index={index} started={false} />
                    }
                })
            }
        } else {
            scenarioSteps = notStartedSteps.map((step, index) => {
                return <RPanelStep details={descriptionData.scenarios[activeScenario].steps[index]} scenarioName={descriptionData.scenarios[activeScenario].scenarioTitle} key={index} index={index} started={false} />
            })
        }

        return (
            <>
                <div className='right-panel-top'>
                    <div className='title'>
                        <div className='main'>Scenario {activeScenario+1}&nbsp;&nbsp;</div>
                        <div className='second'>{props.location.state.description.scenarios[activeScenario].scenarioTitle}</div>
                    </div>
                </div>
                <div className='right-panel-bottom'>
                    {scenarioSteps}
                </div>
                <div className={`right-panel-footer ${loading}`}>
                    <p className='mr-5px server-date-label'>Server date/time</p>
                    <p className='font-weight-bold server-time'>{serverTime.format('MM/DD/YYYY, h:mm A')}</p>
                    <Button
                        id="refresh_tests"
                        btnText="Refresh"
                        handleClick = {refreshClick}
                        icon="redo"
                        iconPlacement="START"
                        outerClass={['refresh-container']}
                        classes={['gi-button__secondary']}
                    />
                </div>
            </>
        )
    };

    return (
        <main className="usa-layout-docs usa-section gi-main-section gi-main-section-edi" id="issuer-edi-testing" onClick={hideSettingPage}>
            <div className="grid-container gi-grid-container">
                {apiError && 
                <div className="usa-alert usa-alert--warning gi-alert gi-alert__error">
                    <div className="usa-alert__body gi-alert__warning__body">
                        <p className="usa-alert__text gi-alert__warning__text">
                            {apiError}
                        </p>
                     </div>
                </div>}
                <RestartModal />
                <div className='f'>
                    <div className='left-panel'>
                        <LeftPanel />
                    </div>
                    <div className='right-panel'>
                        <RightPanel />
                    </div>
                </div>
            </div>
        </main>
    )
}

export default IssuerEdiTestingDetailsContainer;